module.exports = __webpack_public_path__ + "img/benefits01-01.46fa2df.png";